/* global pendo */
import PropTypes from "prop-types";
import React from "react";

const scriptId = "pendo-script";

const pendoScript = `(function(apiKey){
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
  v=['initialize','identify','updateOptions','pageLoad'];
  for(w=0,x=v.length;w<x;++w)(function(m){
  o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push'](
  [m].concat([].slice.call(arguments,0)));};})(v[w]);
  y=e.createElement(n);y.async=!0;
  y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
  z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);
  })(window,document,'script','pendo');
  })('7cd6754c-a688-4232-4c00-52c765806812');`;

class Pendo extends React.PureComponent {
  static get propTypes() {
    return {
      user: PropTypes.object,
    };
  }

  constructor(props) {
    super(props);
    const exists = document.getElementById(scriptId);
    if (!exists) {
      const scriptTag = document.createElement("script");
      scriptTag.setAttribute("id", scriptId);
      scriptTag.textContent = pendoScript;
      document.head.appendChild(scriptTag);
    }

    this.init = this.init.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.init();
    }
  }

  init() {
    const { user } = this.props;
    if (user) {
      const { account, email, name, role, id: userId } = user;

      pendo.initialize({
        visitor: {
          email,
          role,
          full_name: name,
          id: userId,
          // We can add any additional visitor level key-values here.
        },
        account: {
          id: account.id,
          name: account.name,
          // We can add any additional account level key-values here.
        },
      });
    }
  }
  render() {
    return null;
  }
}

export { Pendo, scriptId };
